import script from "./account-main-withdrawal-dialog.vue?vue&type=script&lang=tsx&name=account-main-withdrawal-dialog&setup=true"
export * from "./account-main-withdrawal-dialog.vue?vue&type=script&lang=tsx&name=account-main-withdrawal-dialog&setup=true"

import "./account-main-withdrawal-dialog.vue?vue&type=style&index=0&id=d5f5d9f0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5f5d9f0"]])

export default __exports__